var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-input element-complete"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"title",class:{ on: true }},[_vm._v("알릴의무가 등록되었습니다.")]),_c('div',{staticClass:"label"},[_vm._v(" 입력해주신 내용을 바탕으로 보험심사절차가 진행될 예정입니다. 입력내용에 보충이 필요한 경우 담당 사원이 전화연락을 드릴 수 있습니다. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }